import type { Cart } from '../../../../codegen/types';
import type { PaymentMethodTypes } from '../../../adyen/adyen';
import { UNKNOWN_PAYMENT_METHOD } from '../../../adyen/adyen';
import { getAmount } from '../../../currencyHelper';
import { convertPaymentMethodToGTM } from '../../utils/convertPaymentMethodToGTM';
import { createLineItem } from '../../utils/createLineItem';
import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

export const sendAddPaymentInfoEvent = (
  { currency, total, discountCodes, lineItems }: Cart | Record<string, never>,
  paymentMethodType: PaymentMethodTypes | null,
  cartId: string,
  baseUrl: string,
) => {
  const paymentMethod = paymentMethodType ? convertPaymentMethodToGTM(paymentMethodType) : UNKNOWN_PAYMENT_METHOD;

  sendDataLayerEvent(
    EventNamesType.add_payment_info,
    {
      ecommerce: {
        currency,
        value: +getAmount(total),
        coupon: discountCodes?.map((discount) => discount?.discountCode)?.join(', '),
        payment_type: paymentMethod,
        items: lineItems?.map((item, index) => {
          const { value } = item.price;
          const totalPrice = value.centAmount * item.quantity;
          return {
            ...createLineItem({ ...item, index, images: item.imageURLs, baseUrl }),
            value: +getAmount(totalPrice),
          };
        }),
      },
    },
    true,
    { cartId },
  );
};
